import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.less']
})
export class SideMenuComponent implements OnInit {
  expandMembers = false;
  expandVenues = false;
  expandEvents = false;
  expandPushMessages = false;
  constructor() { }

  ngOnInit() {
  }
  toggleMenu(menuGroup) {
    menuGroup = !menuGroup;
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/side-menu/side-menu.component.ts